import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as actions from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import Card from './Card';
import Machine from './Machine';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';

import { BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-product"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

function DetectError(opening, machines) {
    let days = [];
    let result = false;
    if (opening.length === 0) {
        return true;
    }
    // eslint-disable-next-line array-callback-return
    opening.map((time) => {
        // eslint-disable-next-line array-callback-return
        time.dow.map((day) => {
            if (days.indexOf(day) === -1) {
                days.push(day);
            } else {
                result = true;
            }
        });
    });
    if (machines.length === 0) {
        return true;
    }
    // eslint-disable-next-line array-callback-return
    machines.map((m) => {
        if (!m.nombre || !m.idTipomaquina) {
            result = true;
        }
    });
    return result;
}

class Local extends React.Component {
    state = {
        idLocal: '',
        nombre: '',
        ruta: '',
        activo: false,
        configurado: 0,
        datosapertura: [],
        proximaproduccion: '',
        periodocomanda: '',
        aprobacionpropuesta: '',
        alertaprod: '',
        validacionpropuesta: [],
        maquinaria: [],
        _machinetypes: [],
    };

    constructor(props) {
        super(props);
        props.load(props.id);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    isCorrect = (estado) => {
        return (
            estado &&
            estado.nombre &&
            estado.periodocomanda &&
            estado.aprobacionpropuesta &&
            (!estado.alertaprod || parseInt(estado.alertaprod, 10) >= 10) &&
            !DetectError(estado.datosapertura, estado.maquinaria)
        );
    };

    handleSummit = () => {
        const {
            idLocal,
            nombre,
            ruta,
            datosapertura,
            periodocomanda,
            aprobacionpropuesta,
            alertaprod,
            validacionpropuesta,
            maquinaria,
            activo,
            configurado,
        } = this.state;
        const local = {
            id: this.props.id,
            idLocal: idLocal,
            nombre: nombre,
            ruta: ruta ? ruta : '',
            activo: activo ? true : false,
            datosapertura: datosapertura ? datosapertura : [],
            periodocomanda: periodocomanda ? periodocomanda : '',
            aprobacionpropuesta: aprobacionpropuesta ? aprobacionpropuesta : '',
            alertaprod: alertaprod ? alertaprod : '',
            validacionpropuesta: validacionpropuesta ? validacionpropuesta : [],
            maquinaria: maquinaria ? maquinaria : [],
        };
        if (configurado === 0) {
            this.props
                .add(local)
                .then((r) => {
                    this.props.history.push('/xef/locals');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message });
                });
        } else {
            this.props
                .edit(local)
                .then((r) => {
                    this.props.history.push('/xef/locals');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message });
                });
        }
    };

    static getDerivedStateFromProps(props, state) {
        if (props.local && props.local.idLocal !== state.idLocal) {
            const {
                idLocal,
                nlocal,
                ruta,
                configurado,
                datosapertura,
                proximaproduccion,
                periodocomanda,
                aprobacionpropuesta,
                alertaprod,
                validacionpropuesta,
                maquinaria,
                _machinetypes,
                activo,
            } = props.local;

            state.idLocal = idLocal;
            state.configurado = configurado ? configurado : 0;
            state.nombre = nlocal ? nlocal : '';
            state.ruta = ruta ? ruta : '';
            state.activo = activo ? true : false;
            state.datosapertura = datosapertura ? datosapertura : [];
            state.proximaproduccion = proximaproduccion ? proximaproduccion : '';
            state.periodocomanda = periodocomanda ? periodocomanda : '';
            state.aprobacionpropuesta = aprobacionpropuesta ? aprobacionpropuesta : '';
            state.validacionpropuesta = validacionpropuesta ? validacionpropuesta : [];
            state.maquinaria = maquinaria ? maquinaria : [];
            state.alertaprod = alertaprod ? alertaprod : '';
            state._machinetypes = _machinetypes ? _machinetypes : [];

            return state;
        }
        return null;
    }

    handleChange = (name, value) => {
        const estado = this.state;
        estado[name] = value;
        if (this.isCorrect(estado)) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
        this.setState({ [name]: value, pending_changes: true });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { idLocal, maquinaria, _machinetypes, error } = this.state;
        const { locals_is_loading, locals_has_errored, info } = this.props;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '68')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (locals_has_errored.hasErrored) {
            return <Error open type={locals_has_errored.hasErrored}  message={locals_has_errored.error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {locals_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_row center'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll height100 padding_borders bg_ice_blue showbar'
                            }
                        >
                            <Card
                                local={this.state}
                                id={idLocal}
                                onChange={this.handleChange}
                                info={info}
                            />

                            <Machine
                                id={idLocal}
                                info={maquinaria}
                                types={_machinetypes}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Local.propTypes = {
    local: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    locals_has_errored: PropTypes.object.isRequired,
    locals_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        locals_has_errored: state.locals_has_errored,
        locals_is_loading: state.locals_is_loading,
        local: state.local,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Local));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/local/Index.js